import React, { useState } from 'react';
import { Form, Input, Icon, Popup } from 'semantic-ui-react';
import { NumericFormat, NumberFormatValues } from 'react-number-format';

type FederalItcValues = {
    percentage?: number | null;
};

type Props = {
    values?: FederalItcValues;
    onChange: (values: FederalItcValues) => void;
};

const FederalItc: React.FC<Props> = ({ values = {}, onChange }) => {
    const [formValues, setFormValues] = useState<FederalItcValues>({
        percentage: values.percentage ?? null,
    });

    // useEffect(() => {
    //     onChange(formValues);
    // }, [formValues, onChange]);

    const handleChange = (
        name: string,
        value: any
    ) => {
        setFormValues((prev) => ({
            ...prev,
            [name]: value === '' ? null : Number(value),
        }));
        onChange({ ...formValues, [name]: value === '' ? null : Number(value) });
    };

    return (
        <Form>
            <Form.Field>
                <label>Federal Investment Tax Credit</label>
                <NumericFormat
                    value={formValues.percentage ?? ''}
                    onValueChange={(values: NumberFormatValues) => {
                        handleChange('percentage', values.floatValue ?? null);
                    }}
                    allowNegative={false}
                    placeholder="Enter percentage..."
                    customInput={Input}
                    name="percentage"
                    min={0}
                    max={100}
                    label={{ basic: true, content: '%' }}
                    labelPosition="right"
                />
            </Form.Field>
        </Form>
    );
};

export default FederalItc;